import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Link, Typography } from '@material-ui/core';
import { Launch, GetApp } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  button: {
    [theme.breakpoints.down('sm')]: {
      maxHeight: 80,
    },
  },
}));

const Cargo = () => {
  const classes = useStyles();
  return (
    <Box mt={3}>
      <Typography variant="h6">Locations</Typography>
      <Typography variant="body1">
        We currently offer cargo handling at all our locations
        <b> except Haugesund (HAU), Oslo (OSL), Ålesund (AES) and Svalbard (LYR). </b>
        Please visit the locations page for more information about each airport.
      </Typography>
      <Box mt={2} />
      <Link href="/locations">
        <Button variant="contained" size="large" color="primary" className={classes.button}>
          Locations
        </Button>
      </Link>
      <Box mt={3} />
      <Typography variant="h6">Cargo tracking</Typography>
      <Typography variant="body1">
        Please follow the link below for more information about your shipment.
        You will be redirected to the airline&apos;s tracking system from this portal,
        which show real-time tracking information.
      </Typography>
      <Box mt={2} />
      <Link target="_blank" href="https://www.pakkesporing.no/">
        <Button variant="contained" size="large" color="primary" className={classes.button}>
          Cargo tracking
          <Launch fontSize="small" style={{ marginLeft: 5 }} />
        </Button>
      </Link>
      <Box mt={3} />
      <Typography variant="h6">Documents</Typography>
      <Box mt={2} />
      <Link target="_blank" href="/static/docs/approval_nok_2025.pdf">
        <Button variant="contained" size="large" color="primary" className={classes.button}>
          Shipment opening approval form (Norsk)
          <GetApp fontSize="small" style={{ marginLeft: 5 }} />
        </Button>
      </Link>
      <Box mt={2} />
      <Link target="_blank" href="/static/docs/approval_eng_2025.pdf">
        <Button variant="contained" size="large" color="primary" className={classes.button}>
          Shipment opening approval form (English)
          <GetApp fontSize="small" style={{ marginLeft: 5 }} />
        </Button>
      </Link>
    </Box>
  );
};

export default Cargo;
